import DynamicVideo from "components/DynamicVideo"

export default function InlineVideo({ blok, title, description }) {
  return blok?.video?.length ? (
    <div className="w-full my-4 first:mt-0">
      <DynamicVideo
        component={blok?.video[0]?.component}
        title={blok?.video[0]?.title ?? title}
        description={blok?.video[0]?.description ?? description}
        {...blok?.video[0]}
      />
    </div>
  ) : null
}
